<template>
  <div
    class="checkbox"
    :class="[ isMini && 'checkbox--mini']"
  >
    <input
      :id="id"
      :checked="checked"
      :value="value"
      :type="type"
      :required="isRequired"
      class="checkbox__control"
      @keypress="$event.target.classList.add('touched')"
      @click="$emit('check', {'id':id,'input':$event.target.value})"
      @change="$emit('change', $event)"
    >
    <label
      class="checkbox__label"
      :for="id"
    >
      <v-icon
        class="checkbox__check"
        type="check"
      />
      <slot />
    </label>
  </div>
</template>

<script>
  import Icon from '../Icon';

  export default {
    components: {
      'v-icon': Icon
    },
    props: {
      type: {
        type: String,
        default: 'checkbox'
      },
      id: {
        type: [String, Number],
        default: null,
        required: true
      },
      pattern: {
        type: String,
        default: null
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      isMini: {
        type: Boolean,
        default: false
      },
      value: {
        default: null
      },
      checked: {
        type: [Boolean, Number],
        default: false
      }
    }
  };
</script>
